import "../style/page/AppoinmentsReschedule.scss";
import { useEffect, useState, useMemo } from "react";
import {
    Opipstatuschange,
    OpipcancelList,
    Opipcanceledit,
} from "../../text/apidata";
import axios from "axios";
import { DateRangePicker } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import BasicTable from "../maincomponent/reacttable/table";
import { Tooltip as ReactTooltip } from "react-tooltip";
import noimage from "../../assets/images/noimage.png";
import pdf from "../../assets/images/pdf.png";
import {
    sidebar,
    appoinmentreshedule,
    appoinmentresheduleid,
} from "../redux/reducer/counterslice";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import AppoinmentReschedule from "../form/appoinmentreschedule";
import copy from "copy-to-clipboard";
import { toast } from "react-toastify";
import FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';

export default function IpCancelRequest(props) {
    const sideactive = useSelector((state) => state.counter.sidebarnav);
    const [tableheaderdata, settableheaderdata] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [dtpageindex, setdtPageindex] = useState(1);
    const [dtpagesize, setdtPagesize] = useState(10);
    const [datacount, setdatacount] = useState();
    const [data, setdata] = useState([]);
    const dispatch = useDispatch();
    const [doctorcount, setdoctorcount] = useState(0);
    const [appoinmentcount, setappoinmentcount] = useState(0);
    const [gender, setgender] = useState("all");
    const locationid = useSelector((state) => state.counter.loginuser_location_id)
    const [branches, setbranches] = useState(locationid != "all" ? locationid : "91");
    ;
    const [ageit, setageit] = useState("0");
    const [agegt, setagegt] = useState("120");
    const [popup, setpopup] = useState(false);
    const [id, setid] = useState();
    const [checked, setChecked] = useState(true);
    const [idstatus, setidstatus] = useState("");
    const [popupstatus, setpopupstatus] = useState(false);
    const appoinmentreshedulestate = useSelector(
        (state) => state.counter.appoinmentreshedule
    );
    var today = new Date();

    var it = convert(today);
    var gt = convert(today);
    const [range, setrange] = useState([gt, it]);
    useEffect(() => {
        props.loaderchange("true");
        axios({
            method: "get",
            url: OpipcancelList,
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token") + "",
            },
            params: {
                page: dtpageindex,
                page_size: dtpagesize,
                search: searchQuery,
                status: "",
                type: "IPBill",
                branch: branches,
                date_gt: range[0],
                date_lt: range[1],

            },
        })
            .then((res) => {
                console.log(res.data.data, "ekwfjwek");
                // setdata(res.data.data);
                settableheaderdata(res.data.data);
                setdatacount(res.data.data_count);

                props.loaderchange("false");
            })
            .catch((error) => {
                console.log(error);
                props.loaderchange("false");
                // setdtPageindex(dtpageindex-1)
                props.popupalert("true");
                props.popuptext("No Data Available");
                setTimeout(() => {
                    props.popupalert("false");
                }, 2000);
            });
    }, [dtpageindex, dtpagesize, searchQuery, gender, branches, ageit, agegt, range]);
    const handlechangedate = (name, value) => {
        // let data =value.slice(0, 10)
        if (value != null) {
            setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
        }
    };

    const cleaningrange = () => {
        //setrange([gt,it]);
    };
    function convert(str) {
        var date = new Date(str),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
        return [date.getFullYear(), mnth, day].join("-");
    }
    const predefinedBottomRanges = [
        {
            label: "Today",
            value: [new Date(), new Date()],
            placement: "left",
        },
        {
            label: "Yesterday",
            value: [addDays(new Date(), -1), addDays(new Date(), -1)],
            placement: "left",
        },
        {
            label: "This week",
            value: [startOfWeek(new Date()), endOfWeek(new Date())],
            placement: "left",
        },
        {
            label: "Last 30 days",
            value: [subDays(new Date(), 29), new Date()],
            placement: "left",
        },

        {
            label: "Last week",
            closeOverlay: false,
            value: (value, index) => {
                const [start = new Date()] = value[index] || [];
                return [
                    addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
                    addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
                ];
            },
            appearance: "default",
        },
        {
            label: "Next week",
            closeOverlay: false,
            value: (value, index) => {
                // console.log(value);
                const [start = new Date()] = value[index] || [];
                return [
                    addDays(startOfWeek(start, { weekStartsOn: 0 }), 7),
                    addDays(endOfWeek(start, { weekStartsOn: 0 }), 7),
                ];
            },
            appearance: "default",
        },
    ];

    const deleteappoinment = (e) => {
        setid(e);
        setpopup(true);
    };
    const confirmcancel = (e) => {
        props.loaderchange("true");
        axios({
            method: "put",
            url: Opipstatuschange + id + "/" + "IPBill" + "/" + "Refund",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token") + "",
            },
            data: {
                status: "cancel"
            },
        })
            .then((res) => {
                console.log(res.data);
                setpopup(false);
                // window.location.reload()
                setSearchQuery("");
                props.loaderchange("false");
                props.popupalert("true");
                props.popuptext("Appoinment Cancled Successfully");
                setTimeout(() => {
                    props.popupalert("false");
                }, 2000);
            })
            .catch((error) => {
                console.log(error);
                props.loaderchange("false");
                // setdtPageindex(dtpageindex-1)
                // console.log(dtpageindex)
                props.popupalert("true");
                props.popuptext("No Data Available");
                setTimeout(() => {
                    props.popupalert("false");
                }, 2000);
            });
    };
    const dropdownhandlechange = (e) => {
        dispatch(appoinmentreshedule("edit"));
        dispatch(appoinmentresheduleid(e));
    };

    const confirmstatus = () => {
        props.loaderchange("true");
        axios({
            method: "PUT",
            url: Opipcanceledit + idstatus + "/",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token") + "",
            },
            data: {
                request_status: false,
            },
        })
            .then((res) => {
                console.log(res.data);
                setpopupstatus(false);
                window.location.reload();
                setSearchQuery("");
                props.loaderchange("false");
                props.popupalert("true");
                props.popuptext("Appoinment Closed Successfully");
                setTimeout(() => {
                    props.popupalert("false");
                }, 2000);
            })
            .catch((error) => {
                console.log(error);
                props.loaderchange("false");
                // setdtPageindex(dtpageindex-1)
                // console.log(dtpageindex)
                props.popupalert("true");
                props.popuptext("No Data Available");
                setTimeout(() => {
                    props.popupalert("false");
                }, 2000);
            });
    };
    const columns = useMemo(() => [


        {
            Header: "Patient Name",
            accessor: "",
            Cell: (row) => {
                return (
                    <>
                        <span>
                            <div
                                style={{ marginTop: "3px" }}
                                data-tooltip-id="appoinment"
                                data-tooltip-content={String(
                                    "Ph.No:" + row.row.original.billpaymentip.patient.phonenumber
                                )}
                            >
                                {String(
                                    row.row.original.billpaymentip.patient.first_name + " " +
                                    row.row.original.billpaymentip.patient.last_name
                                )}
                            </div>
                        </span>
                    </>
                );
            },
        },

        {
            Header: "UHID",
            accessor: "",

            Cell: (row) => {
                return (
                    <>
                        <p
                            data-tooltip-id="my-tooltip"
                            data-tooltip-content={row.row.original.billpaymentip.patient.p_uhid}
                        >
                            {String(row.row.original.billpaymentip.patient.p_uhid)}
                        </p>
                    </>
                );
            },
        },

        {
            Header: "Phone Number",
            accessor: "",

            Cell: (row) => {
                return (
                    <>
                        <p
                            data-tooltip-id="my-tooltip"
                            data-tooltip-content={row.row.original.billpaymentip.patient.phonenumber}
                        >
                            {row.row.original.billpaymentip.patient.phonenumber == null ? "--" : row.row.original.billpaymentip.patient.phonenumber}
                        </p>
                    </>
                );
            },
        },


        {
            Header: "Change requested",
            accessor: "",
            Cell: (row) => {
                return (
                    <>
                        <span>
                            <div
                                style={{ marginTop: "3px" }}
                                data-tooltip-id="appoinment"
                                data-tooltip-content={String(
                                    row.row.original.change_requested
                                )}
                            >
                                {String(row.row.original.change_requested)}
                            </div>
                        </span>
                    </>
                );
            },
        },
        {
            Header: "Notes",
            accessor: "",
            Cell: (row) => {
                return (
                    <>
                        <span>
                            <div
                                style={{ marginTop: "3px" }}
                                data-tooltip-id="appoinment"
                                data-tooltip-content={String(
                                    row.row.original.description
                                )}
                            >
                                {row.row.original.description == null ? "--" : row.row.original.description}
                            </div>
                        </span>
                        <button
                            style={{
                                padding: "5px",
                                background: "#5784f5",
                                color: "#fff",
                                fontSize: "14px",
                                border: "none",
                                outline: "none",
                                borderRadius: "10px",
                                cursor: "pointer",
                            }}
                            onClick={(e) => {
                                let isCopy = copy(row.row.original.description);
                                if (isCopy) {
                                    toast.success("Copied to Clipboard");
                                }
                            }}
                        >
                            <i class="fa fa-clone"></i>
                        </button>
                    </>
                );
            },
        },

        {
            Header: "Status",
            accessor: "",
            Cell: (row, index) => {
                // console.log(row.row);

                return (
                    <>
                        <div class="form-check form-switch">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="flexSwitchCheckDefault"
                                checked={row.row.original.request_status}
                                onChange={(e) => {
                                    setidstatus(row.row.original.id);
                                    setChecked(e.target.checked);
                                    // if(e.target.checked==true){
                                    setpopupstatus(true);
                                    // }
                                }}
                                style={{
                                    cursor:
                                        row.row.original.request_status == true
                                            ? "pointer"
                                            : "not-allowed",
                                    pointerEvents: "all",
                                }}
                                disabled={
                                    row.row.original.request_status == true ? false : true
                                }
                            ></input>
                            <label class="form-check-label" for="flexSwitchCheckDefault">
                                {row.row.original.request_status == true
                                    ? "Status Open"
                                    : "Status Closed"}
                            </label>
                        </div>
                    </>
                );
            },
        },

        {
            Header: "Actions",
            accessor: "",
            Cell: (row) => {
                // console.log(row.row.original)
                //settablevalue(row.row.original)

                return (
                    <>

                        <div class="actions">
                            {/* <button
                                    type="button"
                                    class="btn btn-danger btn-sm edit"
                                    onClick={(e) =>
                                        dropdownhandlechange(row.row.original.appointment.id, e)
                                    }

                                    // disabled={row.row.original.appointment.status == 0?false:true}
                                    disabled={row.row.original.request_status == false ? true : false}
                                >
                                    <i class="bi bi-pencil-fill"></i> Reschedule
                                </button> */}
                            <button
                                type="button"
                                class="btn btn-danger btn-sm delete"
                                onClick={(e) => {
                                    deleteappoinment(row.row.original.id, e);
                                }}
                                // disabled={row.row.original.appointment.status == 0?false:true}
                                disabled={row.row.original.request_status == false ? true : false}
                            >
                                <i class="bi bi-trash3"></i> Cancel
                            </button>
                        </div>
                    </>
                );
            },
        },
    ],
        []
    );

    const pagesize = (arg) => {
        setdtPagesize(arg);
    };

    const pageindex = (arg) => {
        setdtPageindex(arg);
    };
    const handleSubmit = (event) => {
        event.preventDefault();
    };
    const loaderchangechild = (arg) => {
        // console.log(arg,"jkh")
        props.loaderchange(arg);
    };
    const popupalertchild = (arg) => {
        props.popupalert(arg);
    };
    const popuptextchild = (arg) => {
        props.popuptext(arg);
    };

    const datadownload = () => {
        props.loaderchange("true");
        axios({
            method: "get",
            url: OpipcancelList,
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token") + "",
            },
            params: {
                page: dtpageindex,
                page_size: dtpagesize,
                search: searchQuery,
                status: "",
                type: "IPBill",
                branch: branches,
                date_gt: range[0],
                date_lt: range[1],

            },
        })

            .then((res) => {
                console.log(res.data.data);
                var downdata = []
                downdata = res.data.data.map((ele, index) => {
                    return {
                        "Patient Name": `${ele.appointment.patient.first_name} ${ele.appointment.patient.last_name}`,
                        "UHID": ele.appointment.patient.p_uhid,
                        "Phone Number": ele.appointment.patient.phonenumber || "--",
                        "Change requested": ele.change_requested,
                        "Notes": ele.description || "--",
                        "Status": ele.request_status ? "Status Open" : "Status Closed",
                        "Paid": ele.appointment.appointmentbookrazorpay.isPaid ? "Yes" : "No",
                    };

                })
                console.log(downdata, 'afhajj')
                const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=UTF-8';
                const fileExtension = '.xlsx';
                const ws = XLSX.utils.json_to_sheet(downdata);
                const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
                const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
                const data = new Blob([excelBuffer], { type: fileType });
                FileSaver.saveAs(data, "IP Cancel Request" + fileExtension);


                props.loaderchange("false");
            })
            .catch((error) => {
                console.log(error);
                props.loaderchange("false");
                // setdtPageindex(dtpageindex-1)
                props.popupalert("true");
                props.popuptext("No Data Available");
                setTimeout(() => {
                    props.popupalert("false");
                }, 2000);
            });
    }
    return (
        <>
            <div className={sideactive ? "dashboard-main-sa" : "dashboard-main"}>
                <div class="page-header">
                    <div class="row">
                        <div class="col-sm-7 col-auto">
                            <h3 class="page-title">IP Cancel Request</h3>
                            <ul class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <NavLink
                                        style={{ textDecoration: "none", color: "#333333" }}
                                        to={"/"}
                                        onClick={(e) => {
                                            dispatch(sidebar("DashBoard"));
                                        }}
                                    >
                                        Dashboard
                                    </NavLink>
                                </li>
                                <li class="breadcrumb-item active">IP Cancel Request</li>
                            </ul>
                        </div>
                        <div class="col-sm-5 col-auto">
                            {" "}
                            <div className="datepicker_dash">
                                <DateRangePicker
                                    defaultValue={[
                                        // new Date(new Date().setDate(today.getDate() - 30)),
                                        new Date(),
                                        new Date(),
                                    ]}
                                    // disabledDate={(date) => isAfter(date, new Date())}
                                    editable={false}
                                    appearance="default"
                                    placement="bottomEnd"
                                    size="lg"
                                    ranges={predefinedBottomRanges}
                                    placeholder="From - To"
                                    style={{ width: 270, padding: 10, float: "right" }}
                                    onClean={(e) => cleaningrange(e)}
                                    onChange={(e) => {
                                        if (e != null) {
                                            setrange([]);
                                            e.forEach((newValue) => {
                                                var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
                                                var localISOTime = new Date(newValue - tzoffset)
                                                    .toISOString()
                                                    .slice(0, -1);
                                                handlechangedate("validtill", localISOTime);
                                            });
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body" style={{ padding: "1.5rem" }}>
                            <form
                                onSubmit={handleSubmit}
                                style={{ display: "flex", justifyContent: "space-between" }}
                            >
                                <div
                                    class="input-group rounded"
                                    style={{ width: "250px", height: "40px" }}
                                >
                                    <input
                                        type="search"
                                        class="form-control rounded"
                                        aria-label="Search"
                                        aria-describedby="search-addon"
                                        value={searchQuery}
                                        onKeyDown={(e) => {
                                            if (e.target.value.length === 0 && e.which === 32) {
                                                e.preventDefault();
                                            }
                                        }}
                                        onInput={(e) => {
                                            if (e.target.value.length <= "100") {
                                                setSearchQuery(e.target.value);
                                            } else {
                                                e.preventDefault();
                                            }
                                        }}
                                        min="0"
                                        max="10"
                                        label="Search"
                                        placeholder="Search..."
                                        required
                                    />
                                    <span
                                        class="input-group-text border-0 bg-transparent"
                                        id="search-addon"
                                    >
                                        <i
                                            class="bi bi-search"
                                            style={{
                                                color: "#1b5a90",
                                                width: "20px",
                                                height: "20px",
                                            }}
                                        ></i>
                                    </span>
                                </div>
                                <div
                                    align="center"
                                    type="button"

                                >
                                    <a class="dnbtn" onClick={(e) => {
                                        datadownload();
                                    }}></a>
                                </div>
                            </form>

                            <div className="table-responsive">
                                <BasicTable
                                    columns={columns}
                                    data={tableheaderdata}
                                    pagesize={pagesize}
                                    pageindex={pageindex}
                                    dtpagesize={dtpagesize}
                                    dtpageindex={dtpageindex}
                                    datacount={datacount}
                                    location={"others"}
                                    setbranches={setbranches}
                                    branches={branches}

                                />
                            </div>
                        </div>
                    </div>
                </div>
                <ReactTooltip
                    id="appoinment"
                    arrowColor="transparent"
                    place="bottom-start"
                    delayShow={50}
                    style={{
                        backgroundColor: "#707070",
                        fontSize: "10px",
                        textAlign: "center",
                        padding: "5px",
                        fontWeight: 400,
                    }}
                />
            </div>
            {popupstatus && (
                <>
                    <div className="logout_popup">
                        <div class="container1">
                            <div class="cookiesContent" id="cookiesPopup">
                                <button
                                    class="close"
                                    onClick={(e) => {
                                        setpopupstatus(false);
                                    }}
                                >
                                    ✖
                                </button>
                                {/* <img src={logoutimg} alt="cookies-img" /> */}
                                <p style={{ marginTop: "20px" }}>
                                    Do you Want to change IP Cancel Request status to Closed?
                                </p>
                                <div style={{ display: "flex" }}>
                                    <button
                                        class="accept p-2 m-2"
                                        onClick={(e) => confirmstatus()}
                                    >
                                        Yes!
                                    </button>
                                    <button
                                        class="accept p-2 m-2"
                                        onClick={(e) => setpopupstatus(false)}
                                    >
                                        No
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
            {popup && (
                <>
                    <div className="logout_popup">
                        <div class="container1">
                            <div class="cookiesContent" id="cookiesPopup">
                                <button
                                    class="close"
                                    onClick={(e) => {
                                        setpopup(false);
                                    }}
                                >
                                    ✖
                                </button>
                                {/* <img src={logoutimg} alt="cookies-img" /> */}
                                <p style={{ marginTop: "20px" }}>
                                    Do You Want to Cancel the IP Cancel Request?
                                </p>
                                <div style={{ display: "flex" }}>
                                    <button
                                        class="accept p-2 m-2"
                                        onClick={(e) => confirmcancel()}
                                    >
                                        Yes!
                                    </button>
                                    <button
                                        class="accept p-2 m-2"
                                        onClick={(e) => setpopup(false)}
                                    >
                                        No
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

        </>
    );
}
